import styled from 'styled-components';

import {
  Form as SemanticForm,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding-top: 170px;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  max-width: 750px;
`;

const Segment = styled(SegmentLayoutComponent)`
  height: 350px;
  width: 100%;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const Title = styled(TextLayoutComponent.Title)`
`;

const Divider = styled.div`
  background-color: ${(props) => props.theme.color.primary};
  height: 3px;
  margin-bottom: 15px;
  margin-top: 5px;
  width: 330px;
`;

const Text = styled(TextLayoutComponent)`
`;

const Form = styled(SemanticForm)`
  margin: 50px 0px;
`;

const Label = styled.span`
  &&&&& {
    color: ${(props) => props.theme.color.textLabel};
    font-size: 16px;
    font-weight: 400;
    margin-right: 10px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.color.textError};
  text-align: center;
`;

const Button = styled(ButtonLayoutComponent)`
  width: 120px;
`;

const ContainerField = styled.div`
    display: flex;
    align-items: center;
`;

export {
  Button,
  Container,
  ContainerField,
  Content,
  Divider,
  ErrorMessage,
  Form,
  Label,
  Segment,
  Text,
  Title,
};
